// src/components/admin/AdminLogin.tsx
import React, { useState } from 'react';

interface AdminLoginProps {
  onLogin: (email: string, password: string) => Promise<void>;
}

const AdminLogin: React.FC<AdminLoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await onLogin(email, password);
    } catch (err: any) {
      setError(err.message || 'Error al iniciar sesión. Verifica tus credenciales.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px',
      background: 'var(--elcristo-bg-light-blue)'
    }}>
      <div className="elcristo-admin-login-box" style={{
        maxWidth: '500px',
        width: '100%'
      }}>
        <div className="elcristo-login-header">
          <h1>Panel de Administración</h1>
          <p>Colegio El Cristo CMS</p>
        </div>

        <form onSubmit={handleSubmit} className="elcristo-login-form">
          {error && (
            <div className="elcristo-alert alert-error">
              <i className="fas fa-exclamation-circle"></i>
              {error}
            </div>
          )}

          <div className="elcristo-form-group">
            <label htmlFor="email">
              <i className="fas fa-envelope"></i>
              Correo Electrónico
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@colegioelcristo.cl"
              required
              disabled={loading}
              className='text-primary'
            />
          </div>

          <div className="elcristo-form-group">
            <label htmlFor="password">
              <i className="fas fa-lock"></i>
              Contraseña
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={loading}
              className='text-primary'
            />
          </div>

          <button 
            type="submit" 
            className="elcristo-btn-login"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="elcristo-spinner-small"></span>
                Iniciando sesión...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i>
                Iniciar Sesión
              </>
            )}
          </button>
        </form>

        <div className="elcristo-login-footer">
          <p>© 2025 Colegio El Cristo. Todos los derechos reservados.</p>
          <p className="elcristo-login-hint">
            <i className="fas fa-info-circle"></i>
            * No compartas tu contraseña con nadie.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;